namespace SPA {
	export namespace Contacts {
		export class StatusList extends Backbone.Collection<SPA.ContactStatus> {
			public constructor(models?: SPA.ContactStatus[], options?: any) {
				// options.model = SPA.ContactStatus;

				super(models, options);
			}

			public preinitialize(models?: SPA.ContactStatus[], options: any = {}): void {
				this.url = location.protocol + '//' + Wollmilch.URL + AJAXCallbase_e.REALTOR + 'contact/contactstatus';

				// Not sure if you need that with correct Collection Model extend
				this.model = SPA.ContactStatus;
			}

			public initialize(models?: SPA.ContactStatus[], options?: any): void
			{
				// Init events here
			}

			public bidder(object_number?: string)
			{
				const bidderStatus = this.findStatus({name: 'bidder', object_number});
				return bidderStatus;
			}

			public owner(object_number?: string)
			{
				return this.findStatus({name: 'owner', object_number});
			}

			public seller(object_number?: string) {
				return this.findStatus({name: 'seller', object_number});
			}

			public customer(object_number?: string) {
				return this.findStatus({name: 'customer', object_number});
			}

			public assignments(): string {
				const list = [];
				for (const status of this.models)
				{
					list.push(status.Name);
				}

				return _.uniq(list).join(', ');
			}

			public modelId(attr: SPA.ContactStatus) {
				return attr.StatusID;
			}

			// Make typescript property check kick in here
			public where(properties: {Name?: IContactStatusName, ObjectNumber?: string})
			{
				return super.where(properties);
			}

			public sync(method: string, model: this, options: any): JQuery.jqXHR {
				switch (method) {
					case 'delete':
						options.url = location.protocol + '//' + Wollmilch.URL + AJAXCallbase_e.REALTOR + 'contact/status/delete';
						break;
				}
				return super.sync(method, model, options);
			}

			public findStatus(options: {name?: IContactStatusName|null, object_number?: string})
			{
				if (options.object_number && options.name) {
					return this.where({Name: options.name, ObjectNumber: options.object_number});
				} else if (options.name) {
					return this.where({Name: options.name});
				} else if (options.object_number) {
					return this.where({ObjectNumber: options.object_number});
				}

				return [];
			}

		}
	}
}
